import { render, staticRenderFns } from "./readaloud.vue?vue&type=template&id=8242f978&scoped=true&"
import script from "./readaloud.vue?vue&type=script&lang=js&"
export * from "./readaloud.vue?vue&type=script&lang=js&"
import style0 from "./readaloud.vue?vue&type=style&index=0&id=8242f978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8242f978",
  null
  
)

export default component.exports